const sar = {
  newSar: 'Nuovo SAR',
  newStep1: 'Passo 1: Scegli l\'utente per presentare un SAR',
  newStep2: 'Passo 2: Scegli la controparte del SAR',
  newStep3: 'Passo 3: Scegli il tipo di anomalia',
  newStep4: 'Passo 4: Gestisci gli effetti del SAR',
  newStep5: 'Passo 5: Emetti il Suspicious Activity Report',
  reasonForSuspicion: 'Motivo del sospetto',
  suspiciousActivitiesReport: 'Suspicious Activities Report',
};

export default sar;
